/* ---------------------------------------------------------------------------
   Legacy header menu fix-ups, run for every visitor.

   Until 2026-09-18 this file was mostly IDEAL (Ideal Image) partner logic. STS
   no longer works with IDEAL, so every IDEAL-only branch is gone. What remains
   is the code that used to run for "every visitor whose code is not IDEAL",
   which is now simply every visitor:

   - the 6th block of the legacy desktop mega menu (li.customproducticon6) is
     hidden;
   - the "-" placeholder item is hidden, desktop and mobile;
   - the SKIN CARE LIBRARY item is kept visible, desktop and mobile.

   All three target markup from sections/custom-mega-menu.liquid and
   snippets/custom-mobile-header.liquid, i.e. the legacy group-header. The v4
   header (sections/sts-header.liquid) has none of these elements.

   v4 chrome (W-A2b). A page that renders the v4 announcement bar
   [data-sts-ann] or header [data-sts-header], and none of the legacy header
   markup, skips the fix-ups above. They could only ever find nothing there,
   and their body-wide MutationObserver re-armed three 10-step polling loops
   on every DOM insertion for the life of the page. Nothing affiliate-specific
   is left for this file to do on the v4 bar. The only thing it ever did to
   the announcement bar was IDEAL's critical CSS on the old Slick bar, which
   went with IDEAL. The v4 bar picks each partner's message set in Liquid and
   CSS from html[data-sts-affiliate], before first paint and without script
   (sections/sts-announcement-bar.liquid). assets/sts-chrome.js owns whatever
   partner colours are still painted, which since 2026-09-19 is nothing on the
   v4 header, footer or buttons — those keep the STS navy on a co-branded page
   and partner identity carries on the logo.

   The legacy selectors are unchanged, so the live theme's header gets exactly
   the same treatment as before.
   --------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
    // v4 chrome and none of the legacy header: nothing below can match. The
    // legacy markers are the header wrapper (sections/header.liquid) and the
    // mega-menu / mobile-menu items this file edits.
    const v4Chrome = document.querySelector('[data-sts-ann], [data-sts-header]');
    const legacyChrome = document.querySelector(
        '[data-header-wrapper], li.hasMegaMenu, .accordion-item-custom-mb, .customspan'
    );
    if (v4Chrome && !legacyChrome) return;

    const hideCustomProductIcon = `
        li.hasMegaMenu.customtitle.customproducticon6 {
            display: none !important;
            visibility: hidden !important;
            width: 0 !important;
            height: 0 !important;
            position: absolute !important;
            overflow: hidden !important;
            opacity: 0 !important;
            pointer-events: none !important;
            clip: rect(0 0 0 0) !important;
            clip-path: inset(50%) !important;
            margin: -1px !important;
        }
    `;
    const styleSheet = document.createElement("style");
    styleSheet.innerText = hideCustomProductIcon;
    document.head.appendChild(styleSheet);

    // Function to wait for elements to be available
    function waitForElements(selector, callback, maxAttempts = 10) {
        let attempts = 0;

        function checkElements() {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
                callback(elements);
                return;
            }

            attempts++;
            if (attempts < maxAttempts) {
                setTimeout(checkElements, 500); // Try again in 500ms
            }
        }

        checkElements();
    }

    // Modify the menu items after ensuring they exist
    function initializeMenuItems() {
        // Keep the SKIN CARE LIBRARY item visible
        waitForElements('.customspan', (customSpans) => {
            customSpans.forEach(span => {
                if (span.textContent.trim() === 'SKIN CARE LIBRARY') {
                    const menuItem = span.closest('li.hasMegaMenu');
                    if (menuItem) {
                        menuItem.classList.remove('hidden');
                        menuItem.style.removeProperty('display');
                    }
                }
            });
        });

        // Hide the "-" placeholder item
        waitForElements('li.hasMegaMenu.customtitle a.menu-link', (placeholderSpans) => {
            placeholderSpans.forEach(span => {
                if (span.textContent.trim() === '-') {
                    const menuItem = span.closest('li.hasMegaMenu');
                    if (menuItem) {
                        menuItem.style.display = 'none !important';
                        menuItem.classList.add('hidden');
                        menuItem.setAttribute('aria-hidden', 'true');
                        menuItem.style.visibility = 'hidden';
                        menuItem.style.position = 'absolute';
                        menuItem.style.width = '0';
                        menuItem.style.height = '0';
                        menuItem.style.overflow = 'hidden';
                        menuItem.style.pointerEvents = 'none';

                        // Also hide the link itself
                        span.style.cssText = `
                            display: none !important;
                            visibility: hidden !important;
                            pointer-events: none !important;
                        `;
                    }
                }
            });
        });

        // Mobile menu: SKIN CARE LIBRARY stays visible, "-" is hidden
        waitForElements('.accordion-title-custom-mb', (mobileAccordionTitles) => {
            mobileAccordionTitles.forEach(title => {
                const text = title.textContent.trim();
                if (text === 'SKIN CARE LIBRARY' || text === '-') {
                    const accordionItem = title.closest('.accordion-item-custom-mb');
                    if (accordionItem) {
                        if (text === 'SKIN CARE LIBRARY') {
                            accordionItem.style.removeProperty('display');
                            accordionItem.classList.remove('hidden');
                        } else {
                            accordionItem.style.display = 'none';
                            accordionItem.classList.add('hidden');
                        }
                    }
                }
            });
        });
    }

    initializeMenuItems();

    // Re-apply when the menus are rendered or re-rendered after load
    const menuObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.addedNodes.length) {
                initializeMenuItems();
            }
        }
    });

    menuObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
});

/* Case-insensitive :contains for jQuery.

   layout/theme.liquid loads jQuery with `async` while this file is deferred,
   so jQuery is often not there yet when this runs, and v4 pages may not load
   it at all. The unguarded version threw "ReferenceError: jQuery is not
   defined" at load. Install it now if jQuery is present, otherwise at
   DOMContentLoaded or at load (an async script that is still downloading
   finishes before the load event). Never throw when jQuery is absent. */
(function () {
    function installContainsCI() {
        const jq = window.jQuery;
        if (!jq || !jq.expr || jq.stsContainsCI) return;
        const pseudos = jq.expr.pseudos || jq.expr[':'];
        if (!pseudos) return;
        pseudos.contains = function(a, i, m) {
            return jq(a).text().toUpperCase()
                .indexOf(m[3].toUpperCase()) >= 0;
        };
        jq.stsContainsCI = true;
    }

    installContainsCI();
    document.addEventListener('DOMContentLoaded', installContainsCI);
    window.addEventListener('load', installContainsCI);
})();
